import React from "react";
import style from "./style.module.scss"
import { ArrowLeftIcon } from "@material-ui/pickers/_shared/icons/ArrowLeftIcon";
import { NavLink, useLocation, useRouteMatch } from "react-router-dom";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useTheme } from "@material-ui/styles"
import config from "../../../config"

export default function DashHeaderCompare({ name, defaultSet}) {
  const { pathname } = useLocation();
  const { params: { type } } = useRouteMatch();
  const { t } = useTranslation();
  const { theme: { bgColors, colors } } = useTheme()
  const theme = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const idList0 = useSelector(state => state.dashboardData.idList[0]);
  const idList1 = useSelector(state => state.dashboardData.idList[1]);

  return (
    <div className={`${style.mainCont}`}>
      <div className={`${style.firstRow}`}>
        <div className={`d-flex align-items-center`} style={{ gridGap: "10px" }}>
          <NavLink to={'/archive'}>
            <Button variant="contained" style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorContrast }} className={`${style.breadcrumbs}`}>
              <ArrowLeftIcon />
              {t('archive')}
            </Button>
          </NavLink>
          {pathname !== `/dashboard/${type}` &&
            <NavLink to={`/dashboard/${type}`}>
              <Button variant="contained" style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorContrast }} className={`${style.breadcrumbs}`}>
                <ArrowLeftIcon />
                {t('dashFiltersboard')}
              </Button>
            </NavLink>
          }
        </div>
        <div className={`${style.variants}`}>
          <div className={`${style.variantsCont}`}>
            {!idList0?.length && <div className={`${style.variant}`} style={{ backgroundColor: bgColors.bgBlue300, color: colors.colorText }}>
              <NavLink to={'/dashboard/compare/filters/single'}   style={{ textDecoration: "none", color: "inherit" }}>
                <p className={`m-0 ${style.text}`}>{t('Auswahll1')}</p>
              </NavLink>
            </div>}
            {!idList1?.length && <div className={`${style.variant}`} style={{ marginRight: "27px", backgroundColor: bgColors.bgDarkYellow, color: colors.colorStatusWarning}}>
              <NavLink to={'/dashboard/compare/filters/double'} style={{ textDecoration: "none", color: "inherit" }}>
                <p className={`m-0 ${style.text}`}>{t('Auswahll2')}</p>
              </NavLink>
            </div>}
          </div>
        </div>
      </div>
      <div className={`${style.secondRow} p-2`} style={{ width: "98%" }}>
        <div className={`d-flex justify-content-between col-12 col-lg-7`} style={{ gridGap: "15px" }}>
          <h1 style={{ color: colors.colorText}} className={`col-12 col-lg-5 mb-2 m-md-0`}>{t("compare-dashboard")} {name}</h1>
        </div>
        {defaultSet && <p style={{ fontStyle: "italic", color: colors.colorText }} className={'pl-4 pr-4 pt-2 pb-0'} dangerouslySetInnerHTML={{ __html: t(`defaultDashboardText-${theme}`) }} />}
      </div>
    </div>
  )
}
